export default __webpack_public_path__ + "static/media/DocLand.a849ac2c.png";